module.exports = __webpack_public_path__ + "static/media/error.cbf53c4c.svg";